<template>
	<b-container fluid>
		<b-modal
			ref="loading-modal"
			id="loading-modal"
			v-model="loadingModal"
			hide-footer
			hide-header
			no-close-on-backdrop
			no-close-on-esc
			centered
		>
			<div class="d-block text-center">
				<b-spinner label="Spinning"></b-spinner>
				<h3>Processando...</h3>
			</div>
		</b-modal>
		<b-card
			class="m-4"
			:header="
				this.$route.params.id ? 'Editar escala' : 'Adicionar escala'
			"
			header-text-variant="white"
			header-tag="header"
			header-bg-variant="success"
			footer="Card Footer"
			footer-tag="footer"
		>
			<b-card-text>
				<b-container fluid>
					<b-row>
						<b-col>
							<b-form-group
								id="input-group-tipo-escala"
								label="Tipo de escala"
								label-for="input-tipo-escala"
							>
								<b-form-select
									v-model="tipoEscala"
									class="mb-3"
									@change="recuperaTiposDePlantao"
								>
									<template v-slot:first>
										<b-form-select-option
											:value="null"
											disabled
											>-- Selecione o tipo de escala
											--</b-form-select-option
										>
									</template>
									<b-form-select-option
										v-for="tipoEscala in tiposEscalas"
										:key="tipoEscala.id"
										:value="tipoEscala"
										>{{
											tipoEscala.descricao
										}}</b-form-select-option
									>
								</b-form-select>
							</b-form-group>
							<b-form-group
								class="col-xl-8 col-lg-12 px-0"
								id="input-group-profissional"
								label="Colaborador"
								label-for="input-profissional"
							>
								<auto-complete
									v-model="profissionalSelecionado"
									:suggestions="profissionaisFiltrados"
									@complete="procuraProfissionais($event)"
									:minLength="3"
									field="nome"
									@item-select="incluiProfissional"
									id="input-profissional"
								>
									<template #item="pessoa">
										<b-container
											fluid
											class="
												d-flex
												justify-content-between
											"
										>
											<div>{{ pessoa.item.nome }}</div>
											<div>{{ pessoa.item.cpf }}</div>
										</b-container>
									</template>
								</auto-complete>
							</b-form-group>
							<b-container class="border" fluid>
								<b-row class="my-2">
									<b-col class="col-lg-6 col-12">
										<b-form-group
											label="Filtro:"
											label-for="input-filtro"
											label-cols="2"
											class="my-0"
										>
											<b-form-input
												v-model="filtro"
												placeholder="Digite para filtrar a tabela"
												id="input-filtro"
											/>
										</b-form-group>
									</b-col>
									<b-col
										class="
											d-flex
											flex-row
											justify-content-end
											mt-2 mt-lg-0
										"
									>
										<b-form-radio-group
											id="checkbox-tipos-profissionais"
											v-model="tipos_profissionais"
											name="tipos-profissionais"
										>
											<b-form-radio value="resmed"
												>RESMED</b-form-radio
											>
											<b-form-radio value="resmulti"
												>RESMULTI</b-form-radio
											>
											<b-form-radio value="interno"
												>INTERNOS</b-form-radio
											>
										</b-form-radio-group>
										<b-button
											variant="primary"
											@click="carregaProfissionaisPorLote"
											:disabled="
												tipos_profissionais == null
											"
											>Carregar em lote</b-button
										>
									</b-col>
								</b-row>
								<b-row>
									<b-col>
										<b-table
											small
											sticky-header
											:items="profissionaisSelecionados"
											:filter="filtro"
											show-empty
											empty-text="Não há dados para exibir"
											:fields="campos_tabela"
										>
											<template v-slot:emptyfiltered>
												<h4>Não há dados</h4>
											</template>
											<template
												v-slot:cell(show_details)="row"
											>
												<b-row
													align-h="end"
													class="mr-1"
												>
													<b-button
														size="sm"
														variant="danger"
														@click="
															excluiProfissional(
																row.item.cpf
															)
														"
													>
														<i
															class="
																fas
																fa-trash-alt
															"
														></i>
													</b-button>
												</b-row>
											</template>
										</b-table>
									</b-col>
								</b-row>
								<b-row class="mb-2">
									<b-col>
										<b-button
											variant="danger"
											@click="apagarLista"
											v-show="
												profissionaisSelecionados.length >
												0
											"
											>Apagar Lista</b-button
										>
									</b-col>
								</b-row>
							</b-container>
							<b-form-group
								id="input-group-datas"
								label="Datas"
								label-for="input-datas"
							>
								<calendar
									v-model="datas"
									:inline="true"
									selectionMode="multiple"
									:locale="br"
									:showButtonBar="true"
									dateFormat="dd"
								/>
							</b-form-group>
							<b-form-group
								id="input-grpup-plantoes"
								label="Plantões"
								label-for="input-plantoes"
							>
								<b-form-select
									v-model="tiposPlantoesSelecionados"
									multiple
								>
									<b-form-select-option
										v-for="tipoPlantao in tiposPlantoes"
										:key="tipoPlantao.id"
										:value="tipoPlantao"
										>{{
											tipoPlantao.descricao
										}}</b-form-select-option
									>
								</b-form-select>
							</b-form-group>
						</b-col>
					</b-row>
					<b-row>
						<b-col>
							<b-button
								variant="success"
								:disabled="!atualizaEscalaEnabled"
								@click="atualizaEscala"
								>Atualizar escala</b-button
							>
						</b-col>
					</b-row>
					<b-row class="mt-3">
						<b-col>
							<b-alert
								v-for="(
									mensagem, index
								) in mensagens_duplicidade"
								:key="index"
								show
								dismissible
								variant="danger"
								>{{ mensagem }}</b-alert
							>
						</b-col>
					</b-row>
					<b-row class="mt-3">
						<b-col>
							<PreviaEscala
								ref="previaEscala"
								:escala="escala"
								:editavel="true"
								@excluiProfEscalaDefinitiva="
									excluiProfEscalaDefinitiva
								"
								@diasSelecionadosChanged="
									diasSelecionadosChanged
								"
								:diasSelecionados="diasSelecionados"
							/>
						</b-col>
					</b-row>
				</b-container>
			</b-card-text>
			<template v-slot:footer>
				<b-container id="rodape" fluid>
					<b-row>
						<b-col>
							<b-button variant="success" @click="salvarEscala">{{
								escala.id != null
									? "Salvar alterações"
									: "Salvar escala"
							}}</b-button>
							<b-button
								class="ml-2"
								variant="danger"
								@click="limparEscala"
								>Limpar escala</b-button
							>
						</b-col>
						<b-col class="d-flex justify-content-end">
							<b-button
								variant="danger"
								@click="limparDiasSelecionados"
								>Limpar selecionados</b-button
							>
						</b-col>
					</b-row>
				</b-container>
			</template>
		</b-card>
	</b-container>
</template>

<script>
import AutoComplete from "primevue/autocomplete";
import Calendar from "primevue/calendar";
import PreviaEscala from "./PreviaEscala";
import mixinToast from "@/mixins/mixinToast.js";

export default {
	data() {
		return {
			escala: {
				id: null,
				mes: null,
				profissionais: [],
				tipo: null,
				criado_por: null,
			},
			diasSelecionados: [],
			tipos_profissionais: null,
			tipoEscala: null,
			tiposEscalas: null,
			tiposPlantoes: null,
			tiposPlantoesSelecionados: [],
			profissionalSelecionado: null,
			profissionaisFiltrados: null,
			mensagens_duplicidade: [],
			datas: [],
			loadingModal: false,
			br: {
				firstDayOfWeek: 0,
				dayNames: [
					"Domingo",
					"Segunda-feira",
					"Terça-feira",
					"Quarta-feira",
					"Quinta-feira",
					"Sexta-feira",
					"Sábado",
				],
				dayNamesShort: [
					"Dom",
					"Seg",
					"Ter",
					"Qua",
					"Qui",
					"Sex",
					"Sab",
				],
				dayNamesMin: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sab"],
				monthNames: [
					"Janeiro",
					"Fevereiro",
					"Março",
					"Abril",
					"Maio",
					"Junho",
					"Julho",
					"Agosto",
					"Setembro",
					"Outubro",
					"Novembro",
					"Dezembro",
				],
				monthNamesShort: [
					"Jan",
					"Fev",
					"Mar",
					"Abr",
					"Mai",
					"Jun",
					"Jul",
					"Ago",
					"Set",
					"Out",
					"Nov",
					"Dez",
				],
				today: "Hoje",
				clear: "Limpar",
				dateFormat: "dd/mm/yyyy",
				weekHeader: "Wk",
			},
			profissionaisSelecionados: [],
			datas_temp: null,
			filtro: null,
			campos_tabela: [
				{ key: "show_details", label: "" },
				{ key: "nome", label: "Nome" },
				{ key: "vin_descricao", label: "Vínculo" },
				{ key: "grf_descricao", label: "Grupo Funcional" },
			],
		};
	},
	mixins: [mixinToast],
	components: {
		AutoComplete,
		Calendar,
		PreviaEscala,
	},
	computed: {
		atualizaEscalaEnabled() {
			return (
				(this.tipoEscala != null &&
					this.profissionaisSelecionados.length > 0 &&
					this.datas.length > 0 &&
					this.tiposPlantoesSelecionados.length > 0) ||
				(this.diasSelecionados.length > 0 &&
					this.tiposPlantoesSelecionados.length > 0)
			);
		},
		diasNoMes() {
			return this.escala.mes != null
				? new Date(
						this.escala.mes.getFullYear(),
						this.escala.mes.getMonth() + 1,
						0 ).getDate()
				: 0;
		},
	},
	methods: {
		recuperaTiposDePlantao() {
			console.log("recupera tipos de plantões");
			console.log(this.tipoEscala);
			this.getTiposPlantoes();
		},
		limparDiasSelecionados() {
			if (this.diasSelecionados.length > 0) {
				for (var i = 0; i < this.diasSelecionados.length; i++) {
					var profissional = this.escala.profissionais.find((p) => {
						return p.cpf == this.diasSelecionados[i].cpf;
					});
					profissional.datas = profissional.datas.filter((data) => {
						return data.dia != this.diasSelecionados[i].dia;
					});
				}
				this.diasSelecionados = [];
				this.$refs.previaEscala.$forceUpdate();
			}
		},
		diasSelecionadosChanged(value) {
			this.diasSelecionados = value;
			console.log(this.diasSelecionados);
		},
		excluiProfEscalaDefinitiva(cpf) {
			console.log("excluido profissonal no adicionar escala" + cpf);
			this.escala.profissionais = this.escala.profissionais.filter(
				(p) => {
					return p.cpf != cpf;
				}
			);
		},
		limparEscala() {
			this.escala.mes = null;
			this.escala.profissionais = [];
			this.escala.tipo = null;
			this.escala.criado_por = null;
		},
		formularioComErro() {
			return this.escala.profissionais.length == 0;
		},
		salvarEscala() {
			// se estiver definido, na verdade isso vai atu

			this.$bvModal
				.msgBoxConfirm("Confira a escala antes de enviar.", {
					title: "Confirma o envio da escala?",
					okVariant: "success",
					okTitle: "Sim",
					cancelTitle: "Não",
					footerClass: "p-2",
					hideHeaderClose: false,
					centered: true,
				})
				.then((value) => {
					if (value) {
						this.$refs["loading-modal"].show();

						if (this.formularioComErro()) {
							alert("O formulário contém erros.");
							return;
						} else {
							this.mensagens_duplicidade = [];
							this.escala.tipo = this.tipoEscala.id;
							this.escala.criado_por =
								this.$store.getters.getLoggedUser.id;
							this.$http
								.post("/escala", this.escala)
								.then((result) => {
									if (Array.isArray(result.data.message)) {
										this.$refs["loading-modal"].hide();
										this.mensagens_duplicidade =
											result.data.message;
										this.exibeToast(
											false,
											"Ocorreu um erro ao salvar a escala."
										);
										return;
									}
									this.exibeToast(
										result.data.success,
										result.data.message
									);
									this.escala.id = result.data.escala_id
									this.$refs["loading-modal"].hide();
								});
						}
					}
				});
		},
		excluiProfissional(cpf) {
			console.log(cpf);
			this.profissionaisSelecionados =
				this.profissionaisSelecionados.filter((p) => {
					return p.cpf != cpf;
				});
		},
		apagarLista() {
			this.profissionaisSelecionados = [];
		},
		daysInMonth(month, year) {
			return new Date(year, month, 0).getDate();
		},
		atualizaEscala() {
			// se o usuário selecionar dias específicos para alterar, vai cair aqui
			if (this.diasSelecionados.length > 0) {
				for (var i = 0; i < this.diasSelecionados.length; i++) {
					var profissional = this.escala.profissionais.find((p) => {
						return p.cpf == this.diasSelecionados[i].cpf;
					});
					var existe = profissional.datas.find((data) => {
						return data.dia == this.diasSelecionados[i].dia;
					});
					// se já existe esse dia no array datas do profissional, vai dar um push apenas no plantão novo
					if (existe) {
						existe.plantoes = existe.plantoes.concat(
							this.tiposPlantoesSelecionados
						);
						existe.plantoes = [...new Set(existe.plantoes)];
					} else {
						//verifica primeiro se esse profissional ainda está na lista temporária
						profissional.datas.push({
							dia: this.diasSelecionados[i].dia,
							plantoes: this.tiposPlantoesSelecionados,
						});
					}
				}
				this.diasSelecionados = [];
				this.$refs.previaEscala.$forceUpdate();
				return;
			}

			this.escala.mes = new Date(
				this.datas[0].getFullYear() +
					"/" +
					(this.datas[0].getMonth() + 1) +
					"/15"
			);
			this.escala.tipo = this.tipoEscala;
			this.escala.criado_por = {
				id: this.$store.getters.getLoggedUser.id,
			};
			this.adicionaProfissionais();
			// adiciona as datas selecionadas a cada um dos profissionais selecionados
			this.adicionaDatas();
			//console.log(this.escala);
			//this.profissionaisSelecionados = [];
			//this.datas = [];
			this.tiposPlantoesSelecionados = [];
			console.log(this.escala);
		},
		adicionaDatas() {
			this.datas_temp = [];
			// gera um array temporário das datas selecionadas com os plantões
			for (let i = 0; i < this.datas.length; i++) {
				this.datas_temp.push({
					dia: this.datas[i].getDate(),
					plantoes: this.tiposPlantoesSelecionados.slice(),
				});
			}
			var existe = null;
			var ref = this;
			this.escala.profissionais.forEach((p) => {
				var profissionalNasDuasListas =
					ref.profissionaisSelecionados.find((pSelecionados) => {
						return pSelecionados.cpf == p.cpf;
					});

				if (profissionalNasDuasListas) {
					ref.datas_temp.forEach((d) => {
						//console.log(p);
						existe = p.datas.find((data) => {
							return data.dia == d.dia;
						});
						// se já existe esse dia no array datas do profissional, vai dar um push apenas no plantão novo
						if (existe) {
							// aqui checa se o plantão novo já existe no dia
							console.log("ja existe plantões nesta data");

              d.plantoes.forEach( (p1) => {
                let existe2 = existe.plantoes.find((p2) =>  p2.id == p1.id )
                if ( !existe2 ){
                  existe.plantoes.push({...p1});
                }
              });

              // console.log(existe.plantoes)
              // console.log(d.plantoes)

							// existe.plantoes = existe.plantoes.concat(
							// 	d.plantoes
							// );
              // console.log(existe.plantoes)
							// existe.plantoes = [...new Set(existe.plantoes)];
              // console.log(existe.plantoes)
						} else {
							//verifica primeiro se esse profissional ainda está na lista temporária
							p.datas.push({ dia: d.dia, plantoes: d.plantoes });
						}
					});
				}
			});
		},
		adicionaProfissionais() {
			var existe;
			this.profissionaisSelecionados.forEach((e) => {
				existe = this.escala.profissionais.find((p) => {
					return e.cpf == p.cpf;
				});
				if (!existe) {
					this.escala.profissionais.push({
						cpf: e.cpf,
						nome: e.nome,
						sem_usuario: !e.sem_usuario ? false : e.sem_usuario,
						datas: [],
					});
				}
			});
			// orderna o array de pessoas
			this.escala.profissionais.sort((p1, p2) => {
				if (p1.nome < p2.nome) return -1;
				else if (p1.nome > p2.nome) return 1;
				else return 0;
			});
		},
		atualizaExibicaoEscala() {},
		getTiposEscalas() {
			this.$http.get("/tipodeescala").then((result) => {
				this.tiposEscalas = result.data;
			});
		},
		getTiposPlantoes() {
			this.$http
				.get(
					`/tipodeplantao?tipo_escala_id=${
						this.tipoEscala ? this.tipoEscala.id : null
					}`
				)
				.then((result) => {
					this.tiposPlantoes = result.data;
				});
		},
		procuraProfissionais(event) {
			this.$http
				.get("/pessoaspornome/" + event.query.toLowerCase())
				.then((result) => {
					console.log("profissionais", result.data);
					this.profissionaisFiltrados = result.data;
					//console.log(result.data);
				});
		},
		carregaProfissionaisPorLote() {
			this.$refs["loading-modal"].show();
			this.$http
				.get("/profissionaisemlote?tipo=" + this.tipos_profissionais)
				.then((result) => {
					console.log("profissionais", result.data);
					this.profissionaisSelecionados =
						this.profissionaisSelecionados.concat(result.data);
					this.$refs["loading-modal"].hide();
					this.tipos_profissionais = null;
				});
		},
		incluiProfissional() {
			let jaExiste = this.profissionaisSelecionados.find((p) => {
				return p.cpf == this.profissionalSelecionado.cpf;
			});
			if (!jaExiste)
				this.profissionaisSelecionados.push(
					this.profissionalSelecionado
				);
			else alert("Profissional já está na tabela.");
			//console.log(this.profissionaisSelecionados);
			this.profissionalSelecionado = null;
		},
	},
	mounted() {
		this.getTiposEscalas();

		//se existir esse parâmetro, então o modo é de edição
		//a gente vai no backend e já traz a escala de lá
		if (this.$route.params.id) {
			this.$http
				.get("/escala/" + this.$route.params.id)
				.then((result) => {
					this.escala = result.data;
					this.tipoEscala = this.escala.tipoEscala;
					this.escala.mes = new Date(this.escala.mes);
					//   new Date(this.escala.mes).getUTCFullYear() +
					//     "-" +
					//     (new Date(this.escala.mes).getUTCMonth() + 1) +
					//     "-" +
					//     "01"
					// );
					this.getTiposPlantoes();
				});
		}
	},
};
</script>

<style>
.p-autocomplete {
	width: 100% !important;
}
.p-inputtext {
	width: 100% !important;
}
.p-datepicker {
	display: flex !important;
	flex-direction: column !important;
}
</style>
